var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3.5,
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3991 4.116C10.3231 4.116 11.0698 4.37733 11.6391 4.9C12.2084 5.42267 12.4931 6.12267 12.4931 7C12.4931 7.98 12.1898 8.708 11.5831 9.184C10.9764 9.65067 10.1551 9.884 9.1191 9.884L9.0771 11.214H7.9711L7.9151 9.002H8.3211C9.2451 9.002 9.96844 8.862 10.4911 8.582C11.0138 8.302 11.2751 7.77467 11.2751 7C11.2751 6.44 11.1071 5.99667 10.7711 5.67C10.4351 5.34333 9.98243 5.18 9.4131 5.18C8.83444 5.18 8.3771 5.33867 8.0411 5.656C7.71443 5.964 7.5511 6.38867 7.5511 6.93H6.3471C6.3471 6.37 6.4731 5.88 6.7251 5.46C6.9771 5.03067 7.33177 4.69933 7.7891 4.466C8.25577 4.23267 8.79244 4.116 9.3991 4.116ZM8.5171 14.084C8.27443 14.084 8.0691 14 7.9011 13.832C7.7331 13.664 7.6491 13.4587 7.6491 13.216C7.6491 12.9733 7.7331 12.768 7.9011 12.6C8.0691 12.432 8.27443 12.348 8.5171 12.348C8.75043 12.348 8.94644 12.432 9.1051 12.6C9.2731 12.768 9.3571 12.9733 9.3571 13.216C9.3571 13.4587 9.2731 13.664 9.1051 13.832C8.94644 14 8.75043 14.084 8.5171 14.084Z",
    fill: "#070A0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.93ec4104cfdbc1b49e402e14c8585e16.svg";
export { ForwardRef as ReactComponent };